import { Loading } from "classes/Loading";

import { LineItemTextField } from "components/formFields/LineItemTextField";
import { LineSkeleton } from "components/formFields/LineSkeleton";
import { LineTableCell } from "components/formFields/LineTableCell";

import { LINE_ITEM_METADATA } from "editConfig";

export function LineAmount(props) {
  const {
    value,
    onValueChange,
    lineReadOnly,
    objectType,
    error,
    readOnly,
    disabled,
  } = props;

  const isLoading = value instanceof Loading;

  return (
    <LineTableCell sx={{ minWidth: "6rem", maxWidth: "6rem" }}>
      {isLoading ? (
        <LineSkeleton />
      ) : (
        <LineItemTextField
          money
          name="amount"
          value={value}
          readOnly={readOnly}
          onValueChange={onValueChange}
          metadata={LINE_ITEM_METADATA[objectType].amount}
          dataTesting="lineAmount"
          error={error}
          lineReadOnly={lineReadOnly}
          disabled={disabled}
        />
      )}
    </LineTableCell>
  );
}
